export default __webpack_public_path__ + "static/media/IconDesc_PressureTank.256.5a556a02.png";